import { useMemo } from 'react';
import { useParams } from 'react-router';
import { useGetLabelQuery } from '../../../api/queries/getLabel';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import LabelsDetailsInnerPage from './LabelsDetailsInnerPage';

const LabelsDetailsPage = () => {
    const { labelId } = useParams<{ labelId: string }>();

    const { data, loading } = useGetLabelQuery({
        fetchPolicy: 'cache-and-network',
        variables: {
            id: labelId,
        },
    });

    const label = useMemo(() => data?.label || null, [data?.label]);

    if (!label && loading) {
        return <LoadingElement />;
    }

    if (!label) {
        return <NotFoundResult />;
    }

    return <LabelsDetailsInnerPage label={label} />;
};

export default LabelsDetailsPage;
